import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner-carrusel',
  templateUrl: './banner-carrusel.component.html',
  styleUrls: ['./banner-carrusel.component.scss']
})
export class BannerCarruselComponent implements OnInit {

  @Input() element:any;
  constructor() { }

  ngOnInit(): void {
  }

}
